module.exports = __webpack_public_path__ + "static/media/donationamount.f8df908e.png";